import Backbone from 'backbone'
import _ from 'lodash'
import template from './api-token-dialog-view.hbs'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import i18n from 'scoreboard/components/i18n'
import CopyReadOnly from 'scoreboard/components/copy-read-only'


/**
 * Dialog that displays the details of a user's API token
 */
const ApiTokenDialogView = Backbone.View.extend({
	/**
	 * @type ApiToken
	 */
	model: null,

	className: 'api-token-dialog-view',

	render () {
		this.$el.empty().append(template(this.context()))
		this.copyReadOnly = new CopyReadOnly({
			el: this.$('.read-only-input'),
			text: this.model.get('token')
		})
		return this
	},

	context () {
		let apiDocsUrl = scoreboardUrl('/resources/api-docs/api-docs.html')
		let apiDocsLink = `<a class="text-link" href="${apiDocsUrl}"`
			+ ' target="_blank" rel="noopener noreferrer">'
			+ i18n.get('admin.apiToken.apiDocs', apiDocsUrl)
			+ '</a>'

		return _.extend({
			apiDocsLink,
			hasClipboard: navigator.clipboard // requires https; https://stackoverflow.com/a/51823007/5656782
		}, this.model.attributes)
	},

	autoRemove: true

})

export default ApiTokenDialogView

ApiTokenDialogView.__filename__ = 'admin/api-tokens/api-token-dialog-view.js'
